import React from 'react'
import Footer from '../Footer'
import BU1 from '../BU1'

function BUOne() {
    window.scrollTo(0,0);
    return (
        <>
            <BU1/>
            <Footer/>
        </>
    )
}

export default BUOne
